import { createGlobalStyle } from 'styled-components'

const UnresetCSS = createGlobalStyle`
    p {
        display: block;
        margin: 1em 0;
    }
    
    h1, h2, h3, h4, h5, h6 {
        display: block;
        font-size: 2em;
        font-weight: bold;
    }
    
    h1 {
        margin: 0.67em 0;
    }
    
    h2 {
        margin: 0.83em 0;
    }
    
    h3 {
        margin: 1em 0;
    }
    
    h4 {
        margin: 1.33em 0;
    }
    
    h5 {
        margin: 1.67em 0;
    }
    
    h5 {
        margin: 2.33em 0;
    }

    ul, ol {
        display: block;
        margin: 1em 0;
        padding-left: 40px;
    }
    
    ol {
        list-style-type: decimal;
    }

    ul {
        list-style-type: disc;
    }

    button {
        padding: 1px 6px;
    }
`

export default UnresetCSS
